/**
 * LG custom PrimeNG 19 theme preset.
 *
 * Overrides the default Lara emerald/green primary palette with the LG brand
 * crimson/red (#ad0a34) so that all PrimeNG design-token-driven styles (buttons,
 * inputs, links, toggle switches, etc.) render in the correct brand color.
 *
 * The palette shades (50-950) were generated from the base brand color using
 * standard tint/shade mixing, matching PrimeNG's own palette() algorithm.
 */
import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

const LgPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#fbf3f5',
      100: '#ebc4ce',
      200: '#dc96a8',
      300: '#cc6781',
      400: '#bd395b',
      500: '#ad0a34',
      600: '#93092c',
      700: '#790724',
      800: '#5f061d',
      900: '#450415',
      950: '#2b030d',
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.100}',
          color: '{primary.700}',
          focusColor: '{primary.800}',
        },
      },
    },
  },
});

export default LgPreset;
